// src/analysis/fertilizacion/fertilizacionProcess.jsx

import pako from 'pako';
import { toast } from 'react-toastify';
import { CANAL_JOB, lanzarAnalisisEnSegundoPlano, tituloAnalisis } from "../../utils/analisisJobs";

export const ejecutarProcesoFertilizacion = async ({
                                                       selectedFile,
                                                       selectedZipFile,
                                                       idMax,
                                                       userData,
                                                       setLoadingProgress,
                                                       setProcessingFinished,
                                                       socket,
                                                       socketSessionID,
                                                       setShowProgressBar,
                                                       setProgress,
                                                       setTitleLoader,
                                                       anchoFaja,
                                                       rangos,
                                                       uiFiltros = {},
                                                   }) => {
    setProgress(0);
    setTitleLoader("Iniciando análisis de fertilización...");
    setShowProgressBar(true);

    try {
        // Mismo CSV comprimido de siempre; el servidor hace insert_csv y el
        // mapeo en segundo plano (la pestaña se puede cerrar).
        const content = await selectedFile.text();
        const blob = new Blob([pako.gzip(content)], { type: 'application/gzip' });

        const campos = {
            session_id: CANAL_JOB,
            id_analisis: String(idMax),
            // ancho_faja es obligatorio en el backend
            ancho_faja: (anchoFaja ?? 0).toString(),
        };
        // Rangos SOLO si son números válidos: si no, el GIS los ve como ausentes.
        const [rMin, rMid, rMax] = Array.isArray(rangos) ? rangos : [null, null, null];
        const appendIfNumber = (key, val) => {
            const n = Number(val);
            if (val !== null && val !== undefined && val !== '' && Number.isFinite(n)) campos[key] = n.toString();
        };
        appendIfNumber('rango_min', rMin);
        appendIfNumber('rango_medio', rMid);
        appendIfNumber('rango_max', rMax);

        setProgress(5);
        setTitleLoader('Enviando archivos al servidor...');
        const respuesta = await lanzarAnalisisEnSegundoPlano({
            tipoAnalisis: 'FERTILIZACION',
            modo: 'NORMAL',
            titulo: tituloAnalisis('FERTILIZACION'),
            idUsuario: userData?.userId,
            idAnalisis: idMax,
            sesionOrigen: socketSessionID,
            pasos: [
                {
                    ruta: '/mongo/insert_csv',
                    campos: { collection_name: 'fertilizacion', session_id: CANAL_JOB },
                    archivos: { file: { blob, nombre: `${selectedFile.name}.gz` } },
                },
                {
                    ruta: '/mapping/fertilizacion',
                    campos,
                    archivos: { shape_file_path: selectedZipFile },
                },
            ],
            ui: uiFiltros,
        });

        setProgress(10);
        setTitleLoader('Fertilización en procesamiento en el servidor. El mapa se actualizará al finalizar...');
        toast.info(respuesta?.message || 'El análisis de fertilización se está procesando en segundo plano.', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 7000,
        });
    } catch (error) {
        console.error("Error al iniciar el proceso de Fertilización:", error);
        const errorMessage = error?.response?.data?.message || error.message || 'Ocurrió un error, consulta con tu administrador.';
        toast.error(errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
        });
        setShowProgressBar(false);
    }
};

// Fertilización siempre necesita el archivo: el análisis corre en segundo
// plano en el servidor a partir de él.
export const ejecutarProcesoSinArchivoFertilizacion = async ({ setShowProgressBar } = {}) => {
    toast.error('Fertilización requiere el archivo de datos para ejecutar el análisis.', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 5000,
    });
    if (typeof setShowProgressBar === 'function') setShowProgressBar(false);
};
